export const CUSTOM_SELECT_CLASS = "cselect";
